import React, { useContext } from 'react'

import { TableContext } from './TableContext'
import Modal from '../../../elem/Modal'

export default ({ deleteFunction }) => {
    const { confirmDeleteModalData ,setConfirmDeleteModalData } = useContext(TableContext)

    return (
        <Modal
            display={confirmDeleteModalData.display}
            confirmAction={() => deleteFunction(confirmDeleteModalData.uploadId, confirmDeleteModalData.formType)} 
            confirmText={`Delete`}
            denyAction={() => setConfirmDeleteModalData({ display: false, uploadId: null, formType: null })}
            denyText={`Cancel`}
            title={'Delete Confirmation'}
        >
            Do you wish to delete Form ID {confirmDeleteModalData.uploadId}?
        </Modal>
    )
}